"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @function nameReducer
 * @param state
 * @param action
 * @returns name state
 */
var name_1 = require("../../actions/name");
function nameReducer(state, action) {
    if (state === void 0) { state = name_1.DefaultState; }
    switch (true) {
        case action.type.includes(name_1.BUILD_NAME): {
            var newState = Object.assign({}, state);
            newState.firstName = action.name.firstName;
            newState.lastName = action.name.lastName;
            newState.allowMinorNameChange = action.name.allowMinorNameChange;
            newState.nameContentConfigs = action.name.nameContentConfigs;
            newState.metadata = action.name.metadata;
            newState.userCiped = action.name.userCiped;
            newState.comingFromANW = action.name.comingFromANW;
            newState.stepUpContextId = action.name.stepUpContextId;
            newState.stepUpPassed = action.name.stepUpPassed;
            return newState;
        }
        case action.type.includes(name_1.CHANGE_NAME): {
            var newState = Object.assign({}, state);
            newState.firstName = action.firstName;
            newState.lastName = action.lastName;
            newState.metadata = action.metadata;
            return newState;
        }
        case action.type.includes(name_1.CHANGE_RISK_LEVEL): {
            var newState = Object.assign({}, state);
            newState.userActionRiskLevel = action.userActionRiskLevel;
            return newState;
        }
        default:
            return state;
    }
}
exports.default = nameReducer;
